import { render, staticRenderFns } from "./DisciplineEdit.vue?vue&type=template&id=5dc2ce28&scoped=true&"
import script from "./DisciplineEdit.vue?vue&type=script&lang=js&"
export * from "./DisciplineEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc2ce28",
  null
  
)

export default component.exports